import React, { FC } from "react";
import { OptimizelyContactPerson } from "../../types/optimizely/articlePage";
import { OptimizelyContentArea } from "../../types/optimizely/base";
import { mapContentToBlock } from "../../utils/mapContentToBlock";
import { ContentArea } from "../ContentArea/ContentArea";
import { ContactBlock, isContactBlock } from "../../types/optimizely/blocks";

interface ContactPersonProps {
  primaryContactPersonsContentArea: OptimizelyContactPerson | ContactBlock;
  secondaryContactPersonsContentArea?: OptimizelyContactPerson;
  informationContentAreaRight: OptimizelyContentArea;
}

const mapOptimizelyContactPersonToContactPerson = (
  contactPerson: OptimizelyContactPerson | ContactBlock,
  firstPerson?: boolean
) => {
  if (!contactPerson) {
    return null;
  }

  if (isContactBlock(contactPerson)) {
    return (
      <div className="max-w-[482px] py-10 px-5 md:px-16">
        {mapContentToBlock(contactPerson)}
      </div>
    );
  }

  if (contactPerson.contentType[1] !== "PersonBlock") {
    return null;
  }

  const {
    firstName: { value: firstName },
    lastName: { value: lastName },
    mobileNumber: { value: mobileNumber },
    mainImage: { expandedValue: mainImage },
    workTitle: { value: workTitle },
    email: { value: email },
  } = contactPerson;

  return (
    <div
      className={`${
        firstPerson ? "max-w-[482px]" : ""
      } py-10 px-5 md:px-16 flex flex-col sm:flex-row`}
    >
      {mainImage?.url ? (
        <img
          src={mainImage?.url}
          className="h-[150px] w-fit mb-1 sm:mb-0 ml-4 sm:ml-0"
        />
      ) : null}
      <div className="ml-4 w-[200px] text-[14px] text-primary break-words">
        <p className="text-[16px] font-bold mb-2 break-words">
          {firstName} {lastName}
        </p>
        <p className="break-words">{workTitle}</p>
        <p className="break-words">Tel: {mobileNumber}</p>
        <a
          className="text-primaryBlue underline break-words"
          href={`mailto:${email}`}
        >
          {email}
        </a>
      </div>
    </div>
  );
};

const ContactPerson: FC<ContactPersonProps> = (props: ContactPersonProps) => {
  const {
    primaryContactPersonsContentArea,
    secondaryContactPersonsContentArea,
    informationContentAreaRight,
  } = props;

  return (
    <div className="max-w-[1320px] mx-auto">
      {/* <div className={`mx-auto flex divide-x-8 divide-neutralYellow`}> */}
      <div
        className={`mx-auto grid grid-cols-1 lg:grid-cols-2 gap-4 [&>*]:col-span-1 [&>*]:w-full [&>*:only-child]:col-span-2 [&>*:last-child:nth-child(odd)]:col-span-2 divide-neutralYellow`}
      >
        {primaryContactPersonsContentArea && (
          <div
            className={`${
              !secondaryContactPersonsContentArea &&
              !informationContentAreaRight
                ? "col-span-full"
                : ""
            } bg-[#E5E5E5]`}
          >
            {mapOptimizelyContactPersonToContactPerson(
              primaryContactPersonsContentArea,
              true
            )}
          </div>
        )}
        {secondaryContactPersonsContentArea?.expandedValue && (
          <div className="bg-[#E5E5E5]">
            {mapOptimizelyContactPersonToContactPerson(
              secondaryContactPersonsContentArea
            )}
          </div>
        )}

        {informationContentAreaRight?.expandedValue && (
          <div
            className={`${
              secondaryContactPersonsContentArea ||
              !primaryContactPersonsContentArea
                ? "col-span-full"
                : ""
            } bg-secondaryGreen`}
          >
            <div className="h-full max-w-[964px] mx-auto py-10 px-16">
              <ContentArea contentArea={informationContentAreaRight} />
            </div>
          </div>
        )}
      </div>
    </div>
  );
};

export default ContactPerson;
